export default "__VITE_ASSET__f35c4370__"